;(function () {

"use strict";

var NewsletterFormView = Backbone.View.extend({
  initialize: function (opts) {
    opts = opts || {};
    this.onSuccess = opts.onSuccess;
    // console.log('init newsletter form');
  },
  error: function (msg) {
    this.$el.removeClass('success');
    this.$el.addClass('error');
    this.$el.find('.error').html(msg);
  },
  success: function (msg) {
    this.$el.removeClass('error');
    this.$el.addClass('success');
    this.$el.find('input, button').attr('disabled', 'disabled');
    this.$el.find('.error').html('');
    // this.$el.find('button').html(msg);

    if (this.onSuccess) {
      this.onSuccess();
    }
  },
  validate: function (email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  },
  events: {
    'submit': function (e) {
      e.preventDefault();
      // window.location.hash = this.$el.attr('id');

      var self = this;
      var url = "//dev.roseandrex.com/subscribe";

      var email = this.$el.find('input').val();

      if (!this.validate(email)) {
        this.error('Please enter a valid email address');
        return; 
      }

      $.post(url, this.$el.serialize(), function (d) {
        if (d.status === 'error') {
          self.error(d.msg);
        } else {
          self.success(d.msg);
        }
      });

      return;
    }
  }
});

module.exports = NewsletterFormView;

}());